/**
 * Toast wrapper. Centralises notification calls so we can swap libraries
 * (or route them into Sentry breadcrumbs, etc.) without touching every caller.
 */
import { toast as hotToast } from 'react-hot-toast';

type ToastOptions = {
  duration?: number;
  id?: string;
};

const DEFAULT_ERROR_DURATION = 6000;
const DEFAULT_SUCCESS_DURATION = 3000;

export const toast = {
  error(message: string, opts?: ToastOptions) {
    return hotToast.error(message, {
      duration: opts?.duration ?? DEFAULT_ERROR_DURATION,
      id: opts?.id,
    });
  },
  success(message: string, opts?: ToastOptions) {
    return hotToast.success(message, {
      duration: opts?.duration ?? DEFAULT_SUCCESS_DURATION,
      id: opts?.id,
    });
  },
  info(message: string, opts?: ToastOptions) {
    return hotToast(message, {
      duration: opts?.duration ?? DEFAULT_SUCCESS_DURATION,
      id: opts?.id,
    });
  },
  loading(message: string, opts?: ToastOptions) {
    return hotToast.loading(message, { id: opts?.id });
  },
  dismiss(id?: string) {
    hotToast.dismiss(id);
  },
};
